import {
  GameStreamProtocol,
  Stream,
  StreamServerStatus,
  StreamStatus,
} from "../GameStream";

export class MockStream implements Stream {
  private static INDEX = 0;

  public id: string;
  public uuid: string;

  public status = StreamStatus.Pending;
  public gameId?: string;
  public serverStatus?: StreamServerStatus;
  public url?: string;
  public rtsp?: string;
  public protocol = GameStreamProtocol.AUTO;
  public audid?: string;

  constructor() {
    MockStream.INDEX++;
    this.id = `${MockStream.INDEX}`;
    this.uuid = `uuid-${MockStream.INDEX}`;
  }
}
